Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

var _clearfix = require('../utils/clearfix');

var _clearfix2 = _interopRequireDefault(_clearfix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: (0, _airbnbPropTypes.childrenOfType)(_Column2['default']),
  condensed: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('condensed', 'largeGutter'),
  largeGutter: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('condensed', 'largeGutter')
}));

var defaultProps = {
  condensed: false,
  largeGutter: false
};

function ColumnRow(_ref) {
  var css = _ref.css,
      children = _ref.children,
      condensed = _ref.condensed,
      largeGutter = _ref.largeGutter,
      styles = _ref.styles;

  return _react2['default'].createElement(
    'div',
    css(styles.row, condensed && styles.row_condensed, largeGutter && styles.row_largeGutter),
    _react2['default'].Children.map(children, function (child) {
      return child && _react2['default'].cloneElement(child, { largeGutter: largeGutter, condensed: condensed });
    })
  );
}

ColumnRow.componentCategory = 'Core';
ColumnRow.displayName = 'ColumnRow';
ColumnRow.propTypes = propTypes;
ColumnRow.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var unit = _ref2.unit;
  return {
    row: Object.assign({}, _clearfix2['default'], {
      // to offset the Column padding (this is different than O2)
      marginLeft: -unit,
      marginRight: -unit
    }),

    row_largeGutter: {
      marginLeft: -1.5 * unit,
      marginRight: -1.5 * unit
    },

    row_condensed: {
      marginLeft: -0.5 * unit,
      marginRight: -0.5 * unit
    }
  };
})(ColumnRow);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/ColumnRow.js
// module id = 31
// module chunks = 168707334958949